import React from "react";
import quesHero from "../../assets/question-hero.svg";
import "./quiz.css";

import { useQuiz } from "../../context";
import { QuestionBank } from "../../context/QuizContext/context/QuizContext.type";
import { QuizDispatchTypeEnum } from "../../utils";

type GamePropsType = {
   game: QuestionBank | null;
};

export function GamePlay({ game }: GamePropsType) {
   const {
      quizState: { currentQuestion },
      quizDispatch,
   } = useQuiz();

   return (
      <div className="card shadow p-3 mb-5 bg-body rounded align-middle card-question ">
         <img src={quesHero} className="card-img-top" alt="Question" />
         <div className="card-body">
            <h5 className="card-title">Question {currentQuestion + 1}/10</h5>
            <p className="card-text">{game?.question}</p>
         </div>
         <ul className="list-group list-group-flush ">
            {game?.options.map((current) => {
               return (
                  <li key={current.option} className="list-group-item">
                     <button
                        type="button"
                        className={
                           current.isSelected
                              ? "btn btn-secondary btn-option"
                              : "btn btn-outline-secondary btn-option"
                        }
                        onClick={() =>
                           quizDispatch({
                              type: QuizDispatchTypeEnum.SELECT_OPTION,
                              payload: {
                                 question: game.question,
                                 option: current.option,
                              },
                           })
                        }>
                        {current.option}
                     </button>
                  </li>
               );
            })}
         </ul>
         <div className="card-body">
            <button
               type="button"
               className="btn btn-info"
               onClick={() => quizDispatch({ type: QuizDispatchTypeEnum.NEXT_QUESTION })}>
               Next
            </button>
         </div>
      </div>
   );
}
